import React, { useState, useRef, useContext, useEffect } from "react";
import LayoutContent from "@iso/components/utility/layoutContent";
import LayoutWrapper from "@iso/components/utility/layoutWrapper";
import moment from "moment";
import IntlMessages from "@iso/components/utility/intlMessages";
import { HTML5Backend } from "react-dnd-html5-backend";
import ImgCrop from "antd-img-crop";
import { Button, Upload, Col, Form, Tooltip, message, Row, DatePicker, Modal, Input, InputNumber, Select, Table, Radio, Space } from "antd";
import { Map } from "immutable";
import Swal from "sweetalert2";
import { DndProvider, useDrag, useDrop } from "react-dnd";
import update from "immutability-helper";
import ApiCall from "./ApiCall";
// import * as XLSX from "xlsx";
import XLSX from "xlsx-js-style";
import FileSaver from "file-saver";
import languageActions from "@iso/redux/languageSwitcher/actions";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
const type = "DragableUploadList";
const { Option } = Select;
const { changeLanguage } = languageActions;

const TextArea = Input;
var CryptoJS = require("crypto-js");

// Called when logout to clear all login credentials in local storage
export function clearToken() {
  // localStorage.removeItem("id_token");
  localStorage.removeItem("accessToken");
  localStorage.removeItem("loginData");
}

// Get access token as bearer token to authenticate API calling
export function getAccessToken() {
  const accessToken = localStorage.getItem("accessToken");
  return accessToken;
}

// Get Login Data stored in local storage during Sign In
export function getLoginData() {
  const data = localStorage.getItem("loginData");
  if (data) {
    const decrypt = aesDecrypt(data);
    const profileData = JSON.parse(decrypt);
    return profileData;
  } else return undefined;
}

export function getMemberProfile(MemberID) {
  return new Promise(async function (resolve, reject) {
    ApiCall.post("/Member/GetMemberProfile/" + MemberID)
      .then((response) => {
        resolve(response.data.RESULT);
      })
      .catch((error) => {});
  });
}

export function getWalletBalance(MemberID, WalletType) {
  return new Promise(async function (resolve, reject) {
    ApiCall.post(
      "/Wallet/GetWalletBalance",
      JSON.stringify({
        MemberID: MemberID,
        WalletType: WalletType,
      })
    )
      .then((response) => {
        resolve(response.data.RESULT);
      })
      .catch((error) => {
        console.log(error);
        reject(error);
      });
  });
}

// Get Token to authenticate to private dasboard routes
export function getToken() {
  try {
    const idToken = localStorage.getItem("accessToken");
    return new Map({ idToken });
  } catch (err) {
    clearToken();
    return new Map();
  }
}

// Check Security Pin to authenticate wallet related functions, return a true or false
export const checkSecurityPin = (MemberID, Password) => {
  return new Promise(async function (resolve, reject) {
    ApiCall.post(
      "/Auth/CheckSecurityPin",
      JSON.stringify({
        MemberID: MemberID,
        Password: Password,
      })
    )
      .then((response) => {
        resolve(true);
      })
      .catch((error) => {
        message.error("交易密码错误");
        resolve(false);
      });
  });
};

export const checkPassword = (MemberID, Password) => {
  return new Promise(async function (resolve, reject) {
    ApiCall.post(
      "/Auth/CheckPassword",
      JSON.stringify({
        MemberID: MemberID,
        Password: Password,
      })
    )
      .then((response) => {
        resolve(true);
      })
      .catch((error) => {
        message.error("Wrong Password");
        resolve(false);
      });
  });
};

export function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file.originFileObj);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

// Remove leading zero for mobile number
export function removeLeadingZero(number) {
  if (number[0] == 0) return number.substring(1);
  else return number;
}

export function dummyRequest({ file, onSuccess }) {
  setTimeout(async () => {
    onSuccess("ok");
  }, 0);
}

// Prompt a confirmation alert for user before making an action, return a true or false
export function confirmationAlert(title = "确定吗？ | Are you sure?", icon = "warning") {
  return new Promise(async function (resolve, reject) {
    Swal.fire({
      title: title,
      //text: "All the information is correct",
      icon: icon,
      showCancelButton: true,
      showCloseButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    }).then(async (result) => {
      if (result.isConfirmed) resolve(true);
      else reject(false);
    });
  });
}

export function beforeUpload(file) {
  const isLt5M = file.size / 1024 / 1024 < 5;
  if (!isLt5M) {
    message.error("File size must be smaller than 5 MB");
  }
  return file.size / 1024 / 1024 < 5 ? true : Upload.LIST_IGNORE;
}

// Return a thousand separator for all integer displays
export function thousandSeparator(x) {
  if (x != undefined) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
}

// Used for ANTD Upload to make the upload list draggable
const DragableUploadListItem = ({ originNode, moveRow, file, fileList }) => {
  const ref = React.useRef();
  const index = fileList.indexOf(file);
  const [{ isOver, dropClassName }, drop] = useDrop({
    accept: type,
    collect: (monitor) => {
      const { index: dragIndex } = monitor.getItem() || {};
      if (dragIndex === index) {
        return {};
      }
      return {
        isOver: monitor.isOver(),
        dropClassName: dragIndex < index ? " drop-over-downward" : " drop-over-upward",
      };
    },
    drop: (item) => {
      moveRow(item.index, index);
    },
  });
  const [, drag] = useDrag({
    type,
    item: { index },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });
  drop(drag(ref));
  const errorNode = <Tooltip title="Upload Error">{originNode.props.children}</Tooltip>;
  return (
    <div ref={ref} className={`ant-upload-draggable-list-item ${isOver ? dropClassName : ""}`} style={{ cursor: "move" }}>
      {file.status === "error" ? errorNode : originNode}
    </div>
  );
};

// A upload list component when needed to upload a list of files
export const UploadImages = ({ productImageListURL, setProductImageListURL, ratio = { x: 278, y: 278 } }) => {
  const moveRow = React.useCallback(
    (dragIndex, hoverIndex) => {
      const dragRow = productImageListURL[dragIndex];
      setProductImageListURL(
        update(productImageListURL, {
          $splice: [
            [dragIndex, 1],
            [hoverIndex, 0, dragRow],
          ],
        })
      );
    },
    [productImageListURL]
  );
  return (
    <Row gutter={[16, 16]} justify="center">
      <Col xs={24} sm={24} md={24} lg={24} xl={24}>
        <Form.Item name="productImageList">
          <DndProvider backend={HTML5Backend}>
            <ImgCrop aspect={ratio.x / ratio.y} quality={1}>
              <Upload
                beforeUpload={beforeUpload}
                maxCount={5}
                accept=".jpg, .jpeg, .png"
                listType="picture"
                customRequest={dummyRequest}
                onChange={(item) => {
                  setProductImageListURL(item.fileList);
                }}
                fileList={productImageListURL}
                itemRender={(originNode, file, currFileList) => (
                  <DragableUploadListItem originNode={originNode} file={file} fileList={currFileList} moveRow={moveRow} />
                )}
              >
                <Button>Choose File</Button>
              </Upload>
            </ImgCrop>
          </DndProvider>
        </Form.Item>
      </Col>
    </Row>
  );
};

// A function that upload file to Alibaba OSS, it takes in the file and file path defined, then return the generated url
export const UploadDocs = (file, Pathway) => {
  return new Promise(async function (resolve, reject) {
    var dataString = "";
    await getBase64(file).then((data) => {
      const splitString = data.split(",");
      dataString = splitString[1];
    });
    var fileType = file.type.split("/");
    var filename = file.name.split(".");

    ApiCall.post(
      "/Utility/UploadFile",
      JSON.stringify({
        DataString: dataString,
        FileType: fileType[1],
        FileName: filename[0],
        Pathway: Pathway + fileType[1],
      })
    ).then(async (response) => {
      const imageList = {
        url: response.data.RESULT,
        imageCategory: "0",
        imageNo: 0,
        fileType: fileType[1],
      };
      resolve(imageList);
    });
  });
};

// Alert Messages

export function AlertSuccessMessage(title) {
  return new Promise(async function (resolve, reject) {
    Swal.fire({
      icon: "success",
      title: title,
    });
  });
}

export function AlertFailedMessage(title) {
  return new Promise(async function (resolve, reject) {
    Swal.fire({
      icon: "error",
      title: title,
    });
  });
}

// Validation Functions that returns a true or false

export function checkProductCode(productCode) {
  return new Promise(async function (resolve, reject) {
    ApiCall.post("/General/CheckProductCode/" + productCode)
      .then((response) => {
        if (response.data.MESSAGE === "SUCCESS") resolve(true);
        else resolve(false);
      })
      .catch((error) => {
        resolve(false);
      });
  });
}

export const CheckPostCode = (PostCode, StateID, CountryID) => {
  return new Promise(async function (resolve, reject) {
    ApiCall.post(
      "/General/CheckPostCode",
      JSON.stringify({
        PostCode: PostCode,
        StateID: StateID,
        CountryID: CountryID,
      })
    )
      .then((response) => {
        resolve(true);
      })
      .catch((error) => {
        message.error(error.response.data.ERROR);
        resolve(false);
      });
  });
};

export function checkEmail(email) {
  return new Promise(async function (resolve, reject) {
    ApiCall.post("/General/CheckNewEmail/" + email, null, { dontLoad: true })
      .then((response) => {
        resolve(true);
      })
      .catch((error) => {
        resolve(false);
      });
  });
}

export function CheckMobile(mobileCode, mobile) {
  return new Promise(async function (resolve, reject) {
    ApiCall.post(
      "/General/CheckNewMobile",
      JSON.stringify({
        MobileCode: mobileCode,
        Mobile: mobile,
      }),
      { dontLoad: true }
    )
      .then((response) => {
        if (response.data.MESSAGE === "SUCCESS") resolve(true);
      })
      .catch((error) => resolve(false));
  });
}

export function CheckIdentity(IdentityType, IdentityValue) {
  return new Promise(async function (resolve, reject) {
    ApiCall.post(
      "/General/CheckNewIdentity",
      JSON.stringify({
        IdentityType: IdentityType,
        IdentityValue: IdentityValue,
      }),
      { dontLoad: true }
    )
      .then((response) => {
        if (response.data.MESSAGE === "SUCCESS") resolve(true);
      })
      .catch((error) => resolve(false));
  });
}

export function CheckUsername(Username) {
  return new Promise(async function (resolve, reject) {
    ApiCall.post("/General/CheckNewUsername/" + Username, null, { dontLoad: true })
      .then((response) => {
        if (response.data.MESSAGE === "SUCCESS") resolve(true);
        else resolve(false);
      })
      .catch((error) => resolve(false));
  });
}

export function CheckPlacementPosition(SponsorID, PlacementID, PlacementPosition, isCreateSubAccount, UpdatedBy) {
  return new Promise(async function (resolve, reject) {
    ApiCall.post(
      "/General/CheckPlacementPositionAvailable",
      JSON.stringify({
        SponsorID: SponsorID,
        PlacementID: PlacementID,
        PlacementPosition: PlacementPosition,
        isCreateSubAccount: isCreateSubAccount,
        UpdatedBy: UpdatedBy,
      }),
      { dontLoad: true }
    )
      .then((response) => {
        resolve(true);
      })
      .catch((error) => {
        message.error("位置已被占用");
      });
  });
}

export function CheckMemberAllowRegisterSubAccount(MemberID, RegisterAmount = 0) {
  return new Promise(async function (resolve, reject) {
    ApiCall.post(
      "/General/CheckMemberAllowRegisterSubAccountV2",
      JSON.stringify({
        MemberID: MemberID,
        RegisterAmount: RegisterAmount,
      }),
      { dontLoad: true }
    )
      .then((response) => {
        resolve(true);
      })
      .catch((error) => {
        resolve(false);
      });
  });
}

export function CheckMemberID(MemberID) {
  return new Promise(async function (resolve, reject) {
    ApiCall.post("/General/CheckMemberID/" + MemberID)
      .then((response) => {
        resolve(true);
      })
      .catch((error) => resolve(false));
  });
}

export function GetMemberSecurityQuestion(MemberID, Language) {
  return new Promise(async function (resolve, reject) {
    ApiCall.post(
      "/Auth/GetMemberSecurityQuestion",
      JSON.stringify({
        MemberID: MemberID,
        Lang: Language,
      })
    )
      .then((response) => {
        resolve(response.data.RESULT);
      })
      .catch((error) => resolve(false));
  });
}

export function CheckMemberSecurityAnswer(MemberID, SecurityID, SecurityAnswer) {
  return new Promise(async function (resolve, reject) {
    ApiCall.post(
      "/Auth/CheckMemberSecurityAnswer",
      JSON.stringify({
        MemberID: MemberID,
        SecurityID: SecurityID,
        SecurityAnswer: SecurityAnswer,
      })
    )
      .then((response) => {
        resolve(true);
      })
      .catch((error) => {
        // message.error("安全问题答案错误" | "Wrong security question answer");
        message.error(error.response.data.ERROR);
        resolve(false);
      });
  });
}

export function CheckPlacementFree(PlacementID, PlacementPosition) {
  return new Promise(async function (resolve, reject) {
    ApiCall.post(
      "/General/CheckPlacementPositionAvailable",
      JSON.stringify({
        PlacementID: PlacementID,
        PlacementPosition: PlacementPosition,
      })
    )
      .then((response) => {
        resolve(true);
      })
      .catch((error) => {
        resolve(false);
        message.error("位置已被占用");
      });
  });
}

export function randomNumber(min, max) {
  return Math.floor(Math.random() * (max - min) + min);
}

export const checkStockBalance = (products, WarehouseID = "W0000001") => {
  return new Promise(function (resolve, reject) {
    var ProductBalance = [];
    products.map((product, index) => {
      ProductBalance.push({
        ProductCode: product.productCode,
        WarehouseID: WarehouseID,
        Quantity: product.quantity,
      });
    });

    ApiCall.post(
      "/Inventory/v1/CheckProductBalance",
      JSON.stringify({
        ProductBalance: ProductBalance,
      })
    )
      .then((response) => {
        var checkStock = true;
        response.data.RESULT.map((stock) => {
          if (stock.stockBalance - stock.quantity < 0) {
            checkStock = false;
          }
        });
        if (!checkStock) message.warning("Insufficient Stock");
        resolve(checkStock);
      })
      .catch(() => {
        message.error("Failed to Checkout");
      });
  });
};

// Format for ReactQuill Editor format

export const modules = {
  toolbar: [
    [{ header: [1, 2, false] }],
    ["bold", "italic", "underline", "strike", "blockquote"],
    [{ list: "ordered" }, { list: "bullet" }, { indent: "-1" }, { indent: "+1" }],
    ["link", "image"],
    ["clean"],
  ],
};

export const formats = ["header", "bold", "italic", "underline", "strike", "blockquote", "list", "bullet", "indent", "link"];

// Editable Table Modules, currently supported string, number, date, select, textarea

const EditableContext = React.createContext(null);

export const EditableRow = ({ index, ...props }) => {
  const [form] = Form.useForm();
  return (
    <Form form={form} component={false}>
      <EditableContext.Provider value={form}>
        <tr {...props} />
      </EditableContext.Provider>
    </Form>
  );
};

export const EditableCell = ({ title, tableName, editable, children, dataIndex, record, handleSave, inputType, selectList, ...restProps }) => {
  const dateFormat = "YYYY-MM-DD";
  const [editing, setEditing] = useState(false);
  const inputRef = useRef(null);
  const form = useContext(EditableContext);
  useEffect(() => {
    if (editing) {
      inputRef.current.focus();
    }
  }, [editing]);

  const toggleEdit = () => {
    setEditing(!editing);
    if (inputType === "date") {
      form.setFieldsValue({
        [dataIndex]: moment(record[dataIndex], "YYYY-MM-DD"),
      });
    } else {
      form.setFieldsValue({
        [dataIndex]: record[dataIndex],
      });
    }
  };

  const save = async () => {
    try {
      const values = await form.validateFields();
      toggleEdit();
      handleSave({ ...record, ...values }, tableName);
    } catch (errInfo) {
      // console.log("Save failed:", errInfo);
    }
  };

  let childNode = children;

  if (editable) {
    childNode =
      editing && inputType === "string" ? (
        <Form.Item
          style={{
            margin: 0,
          }}
          name={dataIndex}
          rules={[
            {
              required: true,
              message: `${title} is required.`,
            },
          ]}
        >
          <Input ref={inputRef} onPressEnter={save} onBlur={save} />
        </Form.Item>
      ) : editing && inputType === "number" ? (
        <Form.Item
          style={{
            margin: 0,
          }}
          name={dataIndex}
          rules={[
            {
              required: true,
              message: `${title} is required.`,
            },
          ]}
        >
          <InputNumber
            ref={inputRef}
            onPressEnter={save}
            onBlur={save}
            //precision={2}
          />
        </Form.Item>
      ) : editing && inputType === "date" ? (
        <Form.Item
          style={{
            margin: 0,
          }}
          name={dataIndex}
          rules={[
            {
              required: true,
              message: `${title} is required.`,
            },
          ]}
        >
          <DatePicker ref={inputRef} onBlur={save} format={dateFormat} />
        </Form.Item>
      ) : editing && inputType === "select" ? (
        <Form.Item
          style={{
            margin: 0,
          }}
          name={dataIndex}
          rules={[
            {
              required: true,
              message: `${title} is required.`,
            },
          ]}
        >
          <Select ref={inputRef} onSelect={save}>
            {selectList.map((item) => (
              <Option value={item.parameterValue}>{item.parameterValue}</Option>
            ))}
          </Select>
        </Form.Item>
      ) : editing && inputType === "textArea" ? (
        <Form.Item
          style={{
            margin: 0,
          }}
          name={dataIndex}
          rules={[
            {
              required: true,
              message: `${title} is required.`,
            },
          ]}
        >
          <TextArea ref={inputRef} onPressEnter={save} onBlur={save} />
        </Form.Item>
      ) : (
        <div
          className="editable-cell-value-wrap"
          style={{
            paddingRight: 24,
          }}
          onClick={toggleEdit}
        >
          {children}
        </div>
      );
  }

  return <td {...restProps}>{childNode}</td>;
};

export const colProps = {
  xs: 24,
  sm: 12,
  md: 12,
  lg: 12,
  xl: 8,
  className: "colstyle",
};

// Encryption functions

export function aesEncrypt(text) {
  var encrypted = CryptoJS.AES.encrypt(text, process.env.REACT_APP_HEADER_KEY);

  return encrypted.toString();
}

export function aesDecrypt(text) {
  var decrypted = CryptoJS.AES.decrypt(text, process.env.REACT_APP_HEADER_KEY);

  return decrypted.toString(CryptoJS.enc.Utf8);
}

// Used to sort Api call data for verification purposes
export function sortObjectByKeys(o) {
  return Object.keys(o)
    .sort()
    .reduce((r, k) => ((r[k] = o[k]), r), {});
}

// Miscellaneous
// A member list popup component that takes in visibility variables, then return the selected member id
export const MemberListSelection = ({ isModalVisible, setIsModalVisible, memberIDChanged, setSelectedMemberID }) => {
  const intl = useIntl();
  const [refresh, setRefresh] = useState(false);
  const [memberList, setMemberList] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [FilterVariable, setFilterVariable] = useState({
    Fullname: "",
    MemberID: "",
  });
  useEffect(async () => {
    await ApiCall.post(
      "/Member/GetMemberSimpleList",
      JSON.stringify({
        Ranking: 0,
        Nationality: 0,
      })
    )
      .then((response) => {
        response.data.RESULT.map((data, index) => {
          data.key = data.memberID;
        });
        setMemberList(response.data.RESULT);
      })
      .catch((erorr) => {
        setMemberList([]);
      });
  }, []);

  useEffect(() => {
    var list = memberList;
    if (FilterVariable.Fullname != "" || FilterVariable.Fullname != null) {
      list = list.filter((item) => item.fullname.toLowerCase().includes(FilterVariable.Fullname.toLowerCase()));
    }

    if (FilterVariable.MemberID != "" || FilterVariable.MemberID != null) {
      list = list.filter((item) => item.memberID.toLowerCase().includes(FilterVariable.MemberID.toLowerCase()));
    }

    setFilteredData(list);
  }, [FilterVariable, memberList]);

  const columns = [
    {
      title: <IntlMessages id="sms.memberID" />,
      dataIndex: "memberID",
      key: "memberID",
      width: "15%",
    },
    {
      title: <IntlMessages id="sms.fullname" />,
      dataIndex: "fullname",
      key: "fullname",
      width: "20%",
    },
    {
      title: <IntlMessages id="sms.mobileNo" />,
      dataIndex: "mobile",
      key: "mobile",
      width: "15%",
      render: (value, row) => {
        return (
          <div>
            {row.mobileCode}
            {row.mobile}
          </div>
        );
      },
    },
    {
      title: <IntlMessages id="sms.nationality" />,
      dataIndex: "nationality",
      key: "nationality",
      width: "10%",
    },
    {
      title: <IntlMessages id="sms.ranking" />,
      dataIndex: "ranking",
      key: "ranking",
      width: "10%",
    },
  ];

  return (
    <Modal
      className="modalclass"
      // title={modalText.title}
      visible={isModalVisible}
      footer={null}
      onCancel={() => {
        setIsModalVisible(false);
      }}
      width={800}
      style={{ borderRadius: "10px" }}
    >
      <LayoutContent>
        <div>
          <Row gutter={[40, 16]} justify="space-between">
            <Col xs={24} sm={12} md={12} lg={12} xl={12} className="colstyle">
              <h1>
                <IntlMessages id="filter.memberID" />
              </h1>
              <Input
                placeholder={intl.formatMessage({ id: "filter.memberID" })}
                value={FilterVariable.MemberID}
                onChange={(e) => {
                  setFilterVariable({
                    ...FilterVariable,
                    MemberID: e.target.value,
                  });
                }}
              />
            </Col>
            <Col xs={24} sm={12} md={12} lg={12} xl={12} className="colstyle">
              <h1>
                <IntlMessages id="filter.memberName" />
              </h1>
              <Input
                placeholder={intl.formatMessage({ id: "filter.memberName" })}
                value={FilterVariable.Fullname}
                onChange={(e) => {
                  setFilterVariable({
                    ...FilterVariable,
                    Fullname: e.target.value,
                  });
                }}
              />
            </Col>
            <Col xs={24} sm={24} md={24} lg={24} xl={24} className="colstyle">
              <Row
                style={{
                  marginTop: "1%",
                  marginRight: "0%",
                  float: "right",
                }}
              >
                <Col>
                  <Button
                    style={{ width: 100 }}
                    type="default"
                    onClick={() => {
                      setFilterVariable({
                        Fullname: "",
                        MemberID: "",
                      });
                      setRefresh(!refresh);
                    }}
                  >
                    <IntlMessages id="filter.reset" />
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>

        <Table
          columns={columns}
          dataSource={filteredData}
          rowKey="ID"
          onRow={(record, rowIndex) => {
            return {
              onClick: (e) => {
                setIsModalVisible(false);
                setSelectedMemberID(record.memberID);
                memberIDChanged(record.memberID);
              },
            };
          }}
        />
      </LayoutContent>
    </Modal>
  );
};

// Can use it to prevent useEffect called upon load for the first time
export const useDidMountEffect = (func, deps) => {
  const didMount = useRef(false);

  useEffect(() => {
    if (didMount.current) func();
    else didMount.current = true;
  }, deps);
};

// export to excel module
export const exportToExcel = (json, fileName, title = "Techbase X 2022") => {
  // run when have record
  if (json.length > 0) {
    const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";

    json.map((e) => {
      for (var key of Object.keys(e)) {
        e[key] = {
          v: e[key],
          t: "s",
          s: { border: { top: { style: "thin" }, left: { style: "thin" }, right: { style: "thin" }, bottom: { style: "thin" } } },
        };
      }
    });

    var header = [];

    // Use to generate header name for excel
    for (var key of Object.keys(json[0])) {
      // Set first letter to upper case
      var string = key[0].toUpperCase() + key.slice(1);

      // Split header by capital letter if not string like ID and PV
      header.push(string.split(!string.match(/(?=[A-Z]{2,})/) ? /(?=[A-Z])/ : /(?=[A-Z]{2,})/).join(" "));
    }

    const ws = XLSX.utils.json_to_sheet(json, { origin: "A5" });

    if (!ws["!merges"]) ws["!merges"] = [];
    ws["!merges"].push({ s: { r: 0, c: 0 }, e: { r: 0, c: header.length - 1 } });
    ws["!merges"].push({ s: { r: 1, c: 0 }, e: { r: 1, c: header.length - 1 } });
    ws["!merges"].push({ s: { r: 2, c: 0 }, e: { r: 2, c: header.length - 1 } });
    ws["!merges"].push({ s: { r: 3, c: 0 }, e: { r: 3, c: header.length - 1 } });
    XLSX.utils.sheet_add_aoa(ws, [[{ v: title, t: "s", s: { font: { name: "Buffalo", sz: 24 }, alignment: { horizontal: "center" } } }]], {
      origin: "A1",
    });
    XLSX.utils.sheet_add_aoa(ws, [[{ v: fileName, t: "s", s: { font: { name: "Buffalo", sz: 12 }, alignment: { horizontal: "center" } } }]], {
      origin: "A2",
    });
    XLSX.utils.sheet_add_aoa(
      ws,
      [[{ v: moment().format("DD MMMM YYYY HH:mm:ss A"), t: "s", s: { font: { name: "Buffalo", sz: 12 }, alignment: { horizontal: "center" } } }]],
      { origin: "A3" }
    );
    XLSX.utils.sheet_add_aoa(ws, [[]], { origin: "A4" });

    // Border style for all header
    var headerStyle = [];
    header.map((e) => {
      headerStyle.push({
        v: e,
        t: "s",
        s: {
          font: { bold: true },
          border: {
            top: { style: "thin" },
            left: { style: "thin" },
            right: { style: "thin" },
            bottom: { style: "thin" },
          },
        },
      });
    });

    XLSX.utils.sheet_add_aoa(ws, [headerStyle], { origin: "A5" });

    // Build the column width
    ws["!cols"] = Object.keys(json[0]).map((v) => {
      var maxx = json.reduce((w, r) => Math.max(w, r[v]?.length ?? 0), 10);
      return { wch: maxx + 2 };
    });
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  }
};

// export to csv module
export const exportToCSV = (json, fileName, header) => {
  // var FileSaver = require("file-saver");
  const fileType = "text/csv;charset=utf-8;";
  const fileExtension = ".csv";

  const ws = XLSX.utils.json_to_sheet(json);
  XLSX.utils.sheet_add_aoa(ws, [header]);

  const jsonKeys = header ? header : Object.keys(json[0]);

  let objectMaxLength = [];
  for (let i = 0; i < json.length; i++) {
    let value = json[i];
    for (let j = 0; j < jsonKeys.length; j++) {
      if (typeof value[jsonKeys[j]] == "number") {
        objectMaxLength[j] = 10;
      } else {
        const l = value[jsonKeys[j]] ? value[jsonKeys[j]].length : 0;

        objectMaxLength[j] = objectMaxLength[j] >= l ? objectMaxLength[j] : l;
      }
    }

    let key = jsonKeys;
    for (let j = 0; j < key.length; j++) {
      objectMaxLength[j] = objectMaxLength[j] >= key[j].length ? objectMaxLength[j] : key[j].length;
    }
  }

  const wscols = objectMaxLength.map((w) => {
    return { width: w };
  });

  ws["!cols"] = wscols;

  const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
  const excelBuffer = XLSX.write(wb, { bookType: "csv", type: "array" });
  const data = new Blob([excelBuffer], { type: fileType });
  FileSaver.saveAs(data, fileName + fileExtension);
};

export const test = () => {
  console.log(`\n\n--------------------==~==~==~==[ STARTING DEMO... ]==~==~==~==--------------------\n`);
  console.log("`XLSX.version` ......... = " + XLSX.version);
  console.log("`XLSX.style_version` ... = " + XLSX.style_version);

  // STEP 1: Create a new Workbook
  const wb = XLSX.utils.book_new();

  // STEP 2: Create data rows
  let row1 = ["a", "b", "c"];
  let row2 = [1, 2, 3];
  let row3 = [
    {
      v: "Courier: 24",
      t: "s",
      s: {
        font: { name: "Courier", sz: 24 },
        border: { top: { style: "medium" }, left: { style: "medium" }, right: { style: "medium" }, bottom: { style: "medium" } },
      },
    },
    { v: "bold & color", t: "s", s: { font: { bold: true, color: { rgb: "FF0000" } } } },
    { v: "fill: color", t: "s", s: { fill: { fgColor: { rgb: "E9E9E9" } } } },
    { v: "line\nbreak!", t: "s", s: { alignment: { wrapText: true } } },
  ];

  // STEP 3: Create Worksheet, add data, set cols widths
  const ws = XLSX.utils.aoa_to_sheet([row1, row2, row3]);
  ws["!cols"] = [{ width: 30 }, { width: 20 }, { width: 20 }];
  XLSX.utils.book_append_sheet(wb, ws, "browser-demo");

  // STEP 4: Write Excel file to browser
  XLSX.writeFile(wb, "xlsx-js-style-demo.xlsx");
};

// export const Setting = ({ showModal, setShowModal, profileData, OTPCallFunction }) => {
//   const [countDown, setCountDown] = useState(0);
//   const [OTP, setOTP] = useState("");
//   const WithdrawOTP = () => {
//     ApiCall.post(
//       "/GoogleAuthendicator/VerificationGoogleAuthenticator",
//       JSON.stringify({
//         MemberID: profileData.memberID,
//         PassCode: "",
//         UpdatedBy: getLoginData().memberID,
//       })
//     )
//       .then((response) => {
//         setCountDown(moment(response.data.RESULT.createdDate).add("s", 180));
//       })
//       .catch((error) => {
//         message.error("Failed to get OTP");
//       });
//   };

//   return (
//     <Modal
//       title="Please enter the OTP"
//       visible={showModal}
//       footer={null}
//       onCancel={() => {
//         setShowModal(false);
//       }}
//     >
//       <div>
//         <div>OTP</div>
//         <Input
//           onChange={(e) => {
//             setOTP(e.target.value);
//           }}
//         />

//         <Button
//           disabled={countDown != 0}
//           style={{ marginRight: "8px" }}
//           onClick={() => {
//             WithdrawOTP();
//           }}
//         >
//           Send OTP
//         </Button>
//         <Button type="primary" onClick={() => {}}>
//           Validate OTP
//         </Button>
//       </div>
//     </Modal>
//   );
// };

export const verifyGoogleAuthenticator = (profile, PassCode) => {
  return new Promise(async function (resolve, reject) {
    ApiCall.post(
      "/GoogleAuthendicator/VerificationGoogleAuthenticator",
      JSON.stringify({
        MemberID: profile.memberID,
        PassCode: PassCode,
        UpdatedBy: getLoginData().memberID,
      })
    )
      .then((response) => {
        resolve(true);
      })
      .catch((error) => {
        message.error(error.response.data.ERROR);

        resolve(false);
      });
  });
};

export const ChangeLanguage = ({ languageModal, setLanguageModal }) => {
  const { language } = useSelector((state) => state.LanguageSwitcher);
  const [selected, setSelected] = useState(language.languageId);
  const dispatch = useDispatch();

  return (
    <Modal
      className="BinaryHintModal"
      title="Change Language"
      closable={false}
      centered
      visible={languageModal}
      onCancel={false}
      onOk={() => {
        dispatch(changeLanguage(selected));
        setLanguageModal(false);
      }}
    >
      <Radio.Group
        onChange={(e) => {
          setSelected(e.target.value);
          // dispatch(changeLanguage(e.target.value));
        }}
        value={selected}
      >
        <Space direction="vertical">
          <Radio value={"chinese"}>中文</Radio>
          <Radio value={"english"}>English</Radio>
          {/* <Radio value={"malay"}>Malay</Radio> */}
        </Space>
      </Radio.Group>
    </Modal>
  );
};

export function reverseString(str) {
  return str.split("").reverse().join("");
}
